import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { AlertService } from '@ui-components/alert';
import { AuthService } from '../auth/services/auth.service';

export const RefreshTokenLinkGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();
  const incomingUrl = navigation?.extractedUrl;
  if (!incomingUrl) return true;
  const hasAccessToken = Object.hasOwn(incomingUrl.queryParams, 'accessToken');
  if (!hasAccessToken && !Object.hasOwn(incomingUrl.queryParams, 'refreshToken')) return true;

  const auth = inject(AuthService);
  const alerts = inject(AlertService);
  const location = inject(Location);
  const cleanUrl = router.parseUrl(router.serializeUrl(incomingUrl));
  const {
    accessToken,
    refreshToken,
    ApiKey: _legacyKey,
    apiKey: _legacyAlias,
    ...queryParams
  } = cleanUrl.queryParams;
  cleanUrl.queryParams = queryParams;
  location.replaceState(router.serializeUrl(cleanUrl));

  const outcome = hasAccessToken
    ? auth.acceptAccessTokenLink(typeof accessToken === 'string' ? accessToken : '')
    : await auth.restoreSessionFromRefreshToken(
        typeof refreshToken === 'string' ? refreshToken : '',
        () => router.getCurrentNavigation()?.id === navigation?.id
      );
  if (outcome === 'invalid_link') {
    alerts.showError('This sign-in link is invalid or has expired. Please log in.');
  } else if (outcome === 'temporary_failure') {
    alerts.showError('Unable to sign in with this link. Please try again later.');
  }

  return new RedirectCommand(cleanUrl, { replaceUrl: true });
};
